import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Avatar } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { MdOutlineWarningAmber } from "react-icons/md";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Menu, MenuItem } from "@szhsin/react-menu";
import { IoIosCloseCircleOutline } from "react-icons/io";
import IconButton from "@material-ui/core/IconButton";
import style from "src/Assets/css/Moderator/Managemembes.module.css";
import API from "../../../network";
import CircularProgress from "@material-ui/core/CircularProgress";
import { PiDotsThreeBold } from "react-icons/pi";
import AvatarBadge from "src/Components/AvatarBadge";
import alreadyImpactfulMemberImg from "src/Assets/images/already_impactful_img.png";
import feedstyles from "src/Assets/css/home/feedpost.module.css";

const isPrimaryModerator = (user, tenantId, userDetails, moderatingCommunitysData) => {
  if (!user) return false;

  const directIsPM =
    user.isPM == 1 ||
    user.isPM === "1" ||
    user.isPM === "Y" ||
    user.ispm == 1 ||
    user.ispm === "1" ||
    user.ispm === "Y" ||
    user.is_primary_moderator == 1 ||
    user.is_primary_moderator === "1" ||
    user.isCurrentCommunityPm == 1 ||
    user.isCurrentCommunityPm === "1" ||
    user.mainuserdata?.isPM == 1 ||
    user.mainuserdata?.isPM === "1" ||
    user.mainuserdata?.isPM === "Y" ||
    user.mainuserdata?.ispm == 1 ||
    user.mainuserdata?.ispm === "1" ||
    user.mainuserdata?.ispm === "Y" ||
    user.mainuserdata?.is_primary_moderator == 1 ||
    user.mainuserdata?.is_primary_moderator === "1" ||
    user.mainuserdata?.isCurrentCommunityPm == 1 ||
    user.mainuserdata?.isCurrentCommunityPm === "1";

  if (directIsPM) return true;

  const currentRestriction = moderatingCommunitysData?.restrictions?.find(
    (r) => String(r.tenantId) === String(tenantId)
  );
  const isCurrentCommunityPm =
    currentRestriction?.isPm === "1" ||
    currentRestriction?.isPm === 1 ||
    (String(userDetails?.userData?.tenantId) === String(tenantId) &&
      (userDetails?.userData?.isCurrentCommunityPm === "1" ||
        userDetails?.userData?.isCurrentCommunityPm == 1));

  if (isCurrentCommunityPm) {
    const loggedInId =
      userDetails?.userData?.User_ID ||
      userDetails?.userData?.userId ||
      userDetails?.userData?.id;
    const userId = user.id || user.userId || user.User_ID || user.userid;
    if (loggedInId && userId && String(loggedInId) === String(userId)) {
      return true;
    }
    if (
      userDetails?.userData?.displayName &&
      user.displayName &&
      userDetails.userData.displayName.trim().toLowerCase() ===
        user.displayName.trim().toLowerCase()
    ) {
      return true;
    }
  }

  return false;
};

const isModeratorUser = (user, tenantId, userDetails, moderatingCommunitysData) => {
  if (!user) return false;
  const isMod =
    user.isModerator == 1 ||
    user.isModerator == 2 ||
    user.isModerator === "1" ||
    user.isModerator === "2" ||
    user.mainuserdata?.isModerator == 1 ||
    user.mainuserdata?.isModerator == 2 ||
    user.mainuserdata?.isModerator === "1" ||
    user.mainuserdata?.isModerator === "2";

  return (
    isMod &&
    !isPrimaryModerator(user, tenantId, userDetails, moderatingCommunitysData)
  );
};

function ManagememModerator(props) {
  const { tenantId } = props || {};
  const data = useSelector(
    (state) => state.ManagemembersReducer.ManagemebersData,
  );
  const userDetails = useSelector(
    (state) => state.SignInReducer?.userDetails || {},
  );
  const moderatingCommunitysData = useSelector(
    (state) => state.ModeratorReducer?.moderatingCommunitysData || {},
  );

  const isLoading = useSelector(
    (state) => state.ManagemembersReducer.isLoading,
  );
  // const dispatch = useDispatch();
  // let serverImageURL = process.env.REACT_APP_SKOPIC_IMAGE;
  const [membersData, setMembersData] = useState([]);

  useEffect(() => {
    const filteredData = data?.filter(
      (each) =>
        (each?.isModerator === "1" ||
          each?.isModerator === "2" ||
          each?.isModerator == 1 ||
          each?.isModerator == 2) &&
        !isPrimaryModerator(
          each,
          tenantId,
          userDetails,
          moderatingCommunitysData,
        ),
    );
    setMembersData(filteredData);
  }, [data, tenantId, userDetails, moderatingCommunitysData]);

  const onRemoveAsModerator = (userID) => {
    let formData = new FormData();
    formData.append("tenantId", tenantId);
    formData.append("rejectedIds", userID);
    API.inviteAsModerator(formData)
      .then((response) => {
        const updatedData = membersData.filter((each) => each.id !== userID);
        setMembersData(updatedData);
        alert("removed as moderator");
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const warnUserCommunity = (userID) => {
    let formData = new FormData();
    formData.append("tenantId", tenantId);
    formData.append("userId", userID);
    formData.append(
      "warnMessage",
      `Your Community moderator has noted that the content you posted recently in crossword is not in compliance with the <a id="userguidlines" href="${process.env.REACT_APP_SERVICES_API}jsonindex/user-guide" tabindex="41">user guidelines</a> of Skopic. As a matter of courtesy and requirement, we ask that everyone of us maintain the decorum of our online Community by following the best practices for sharing content. Please be advised that any future noncompliance shall result in blocking you from the Community`,
    );
    API.warnUser(formData)
      .then((response) => {
        alert("Warning sent successfully");
        console.info(response);
      })
      .catch((error) => {
        alert("Something went wrong");
        console.error(error);
      });
  };

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <CircularProgress size={30} />
      </div>
    );
  }

  if (!membersData?.length) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        No moderators found !
      </div>
    );
  }

  return (
    <div className={style.container}>
      {membersData.map((result) => (
        <div className={style.communityUsers} key={`key-${result?.id}`}>
          <div className={style.avatharuser}>
            <AvatarBadge
              className={style.Linkedinimage}
              src={result.uimage}
              alt="image"
              isPrimaryModerator={isPrimaryModerator(
                result,
                tenantId,
                userDetails,
                moderatingCommunitysData,
              )}
              isModerator={isModeratorUser(
                result,
                tenantId,
                userDetails,
                moderatingCommunitysData,
              )}
            />
            <div>
              <span className={feedstyles.profilename}>
                {result?.displayName}
                {result?.isImpactableMember === "yes" && (
                  <img
                    src={alreadyImpactfulMemberImg}
                    alt="Impactful Member"
                    title="Impactful Member"
                    style={{
                      width: "18px",
                      height: "18px",
                      objectFit: "contain",
                      flexShrink: 0,
                      marginLeft: "5px",
                    }}
                  />
                )}
              </span>
              {result.isModerator === "1" || result.isModerator === "2" ? (
                <p style={{ margin: 0, fontSize: "14px", color: "gray" }}>
                  Moderator
                </p>
              ) : null}
            </div>
          </div>
          <div className={style.dropdown}>
            <Menu
              menuButton={
                <IconButton
                  style={{
                    padding: 0,
                    width: 30,
                    height: 30,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    outline: "none",
                  }}
                >
                  {/* <MdKeyboardArrowDown fontSize={25} /> */}
                  <PiDotsThreeBold fontSize={25} color="rgba(0, 0, 0, 0.7)" />
                </IconButton>
              }
              transition
              direction="bottom"
              arrow
              menuStyle={{
                backgroundColor: "white",
                borderRadius: 20,
              }}
              align="end"
            >
              <MenuItem onClick={() => onRemoveAsModerator(result.id)}>
                <div style={{ display: "flex", alignItems: "center", width: "100%", padding: "0.375rem 1.25rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                  <IoIosCloseCircleOutline
                    style={{
                      fontSize: "18px",
                      marginRight: "10px",
                      flexShrink: 0,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                  />
                  <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Remove as moderator</span>
                </div>
              </MenuItem>
              <MenuItem onClick={() => warnUserCommunity(result.id)}>
                <div style={{ display: "flex", alignItems: "center", width: "100%", padding: "0.375rem 1.25rem", boxSizing: "border-box", cursor: "pointer", whiteSpace: "nowrap" }}>
                  <MdOutlineWarningAmber
                    style={{
                      fontSize: "18px",
                      marginRight: "10px",
                      flexShrink: 0,
                      color: "rgba(0, 0, 0, 0.7)",
                    }}
                  />
                  <span style={{ fontSize: "14px", whiteSpace: "nowrap" }}>Send warning</span>
                </div>
              </MenuItem>
            </Menu>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ManagememModerator;
